<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">退款住户：</span>
        </div>
        <el-select v-model="refundPayerCodes"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod1"
                   placeholder="请选择退款住户">
          <el-option v-for="item in refundPayerList" :key="item.enterpriseCode"
                     :label="item.enterpriseName" :value="item.enterpriseCode">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">账单名称：</span>
        </div>
        <el-select v-model="paymentItemCodes"
                   filterable
                   remote
                   reserve-keyword
                   size="small" style="width: 280px"
                   :remote-method="remoteMethod2"
                   placeholder="请选择退款账单">
          <el-option v-for="item in chargeBillList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">缴费时间：</span>
        </div>
        <el-date-picker
          v-model="timevalue"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          style="width: 280px">
        </el-date-picker>
      </div>
      <!-- <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">缴费住户：</span>
        </div>
        <el-input v-model="formData.enterpriseName" size="small" style="width: 280px" disabled />
      </div> -->
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">账单金额：</span>
        </div>
        <el-input v-model="formData.billAmount" size="small" style="width: 280px" disabled>
          <template slot="append">元</template>
        </el-input>
      </div>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">退款金额：</span>
        </div>
        <el-input v-model="formData.refundAmount" size="small" style="width: 280px" >
          <template slot="append">元</template>
        </el-input>
      </div>


      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>

  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { errorHandler } from "../../../utils/errorHandler";
import { api } from "../../api/CustomPayment";
import { nError, nSuccess } from "../../../utils/notice";
import ButtonConfirmNext from "../../../components/Button/ButtonConfirmNext";

export default {
  components: {
    ButtonConfirmNext,
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "refund-management-add",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧收费",
          name: "charge-items-management"
        },
        {
          value: "退款管理"
        }
      ],
      mainTitle: "添加住户退款",
      subheading: "",
      payChannelModifyList: [
        {
          key: "1",
          label: "微信"
        },
        {
          key: "2",
          label: "支付宝"
        },
        {
          key: "3",
          label: "银行转账"
        },
        {
          key: "4",
          label: "现金"
        },
        {
          key: "5",
          label: "其他"
        }
      ],
      payStatusModifyList: [
        {
          key: "0",
          label: "未缴费"
        },
        {
          key: "2",
          label: "完全支付"
        }
      ],
      invoiceStatusModifyList: [
        {
          key: "0",
          label: "未开票"
        },
        {
          key: "1",
          label: "已开票"
        }
      ],
      formData: {
        enterpriseCode:"",
        billAmount:""
      },
      refundPayerCodes: "",
      refundPayerList: [],
      chargeBillCodes: "",
      chargeBillList: [],
      timevalue:[],
      paymentItemCodes:""
    };
  },
  created() {
    this.currentCode = this.$route.params.id;
    this.remoteMethod1();
    this.remoteMethod2();
  },
  methods: {
    remoteMethod1(query) {
      this.getChargeBillEnterpriseList(query);
    },
    remoteMethod2(query) {
      this.getRelationBill(query);
    },
    //获取退款对象列表
    getChargeBillEnterpriseList(searchKey) {
      this.$axios
        .post(api.getChargeBillEnterpriseList, { searchKey: searchKey || "" })
        .then(res => {
          let data = res.data.data;
          this.refundPayerList = data;
        })
        .catch(errorHandler("获取退款对象列表失败"));
    },
    // 获取已付款账单列表
    getRelationBill(searchKey) {
      this.$axios
        .post(api.getPaymentItemList,{chargeMode : "经办人代收",chargeType : "个人",searchKey:searchKey||""})
        .then(res => {
          let data = res.data.data;
          this.chargeBillList = data;
        })
        .catch(errorHandler("获取退款对象列表失败"));
    },

    toManagement() {
      this.$router.push({
        name: "refund-management"
      });
    },
    getTotalAmount() {
      this.$axios
        .post(api.getTotalAmount, this.formData)
        .then(res => {
            this.formData.billAmount=res.data.data
          console.log(this.formData.billAmount)
        })
        .catch(errorHandler("查询信息失败"));
    },
    confirm() {
      if(this.timevalue){
        this.formData.startTime = this.timevalue[0];
        this.formData.endTime = this.timevalue[1];
      }else{
        this.formData.startTime=""
        this.formData.endTime = ""
      }
      if (!this.formData.enterpriseCode) {
        nError("请选择退款住户");
        return false;
      }
      if (!this.formData.paymentItemCode) {
        nError("请选择账单名称");
        return false;
      }
      if (!this.formData.startTime) {
        nError("请选择缴费时间");
        return false;
      }
      if (!this.formData.refundAmount) {
        nError("请输入退款金额");
        return false;
      }
      if(this.formData.billAmount=='0.00'){
        nError("账单金额为0，无法退款");
        return
      }
      this.$axios
        .post(api.refundByCompany, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("添加成功");
            this.toManagement();
          }
        })
        .catch(errorHandler("添加失败"));
    },
    cancel() {
      this.toManagement();
    }
  },
  watch: {
    refundPayerCodes(val) {
      this.refundPayerList.map(v => {
        if (v.enterpriseCode === val) {
          this.formData.enterpriseName = v.enterpriseName;
          this.formData.enterpriseCode=v.enterpriseCode
        }
      });
      // this.remoteMethod2()
    },
    timevalue(){
      if(this.timevalue){
        this.formData.startTime = this.timevalue[0];
        this.formData.endTime = this.timevalue[1];
      }else{
        this.formData.startTime=""
        this.formData.endTime = ""
      }
      this.getTotalAmount()
    },
    paymentItemCodes(val){
      this.chargeBillList.map(v=>{
        if(v.code==val){
          this.formData.paymentItemCode=v.code
          this.formData.paymentItemName=v.name
          this.formData.chargeMode=v.chargeMode
          this.formData.chargeType=v.chargeType
        }
      })
    }
    // chargeBillCodes(val) {
    //   this.chargeBillList.map(v => {
    //     if (v.code === val) {
    //       this.formData.paymentItemCode = v.code;
    //       this.formData.billAmount = v.chargeAmount;
    //     }
    //   });
    // }
  }
};
</script>

<style scoped>
form {
  width: 90%;
  margin: 0 auto;
  text-align: left;
}
.red {
  color: #ff0000;
}
.form-line {
  margin: 20px 0;
}
.line-text {
  color: #48576a;
  font-size: 14px;
  margin-right: 10px;
}
.textBox {
  display: inline-block;
  width: 140px;
  line-height: 32px;
  text-align: right;
}
.form-btn-box {
  width: 530px;
  padding: 0 124px;
  margin: 40px 0;
  display: flex;
  justify-content: space-between;
}
</style>

<style lang="less">
.el-input--mini .el-input__inner {
  height: 32px;
  line-height: 32px;
}
.el-date-editor .el-range-separator{
  width:10% !important;
}
</style>



// WEBPACK FOOTER //
// src/view/CustomPayment/RefundManagement/RefundAddByCompany.vue